/*
 * MIT License
 *
 * Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (https://sindresorhus.com)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

// Code appropriated from: https://github.com/sindresorhus/array-move

export default class ArrayUtil {

    static arrayMoveMutable = (array, fromIndex, toIndex) => {
        const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;

        if (startIndex >= 0 && startIndex < array.length) {
            const endIndex = toIndex < 0 ? array.length + toIndex : toIndex;

            const [item] = array.splice(fromIndex, 1);
            array.splice(endIndex, 0, item);
        }
    }

    static arrayMoveImmutable = (array, fromIndex, toIndex) => {
        array = [...array];
        ArrayUtil.arrayMoveMutable(array, fromIndex, toIndex);
        return array;
    }

    /**
     * Finds a property in an array
     * @param array             Array to traverse
     * @param propertyKey       Object property name to match against
     * @param propertyValue     Property Value to find to match
     * @param transformation    A function which can be used as a callback to transform the property value (useful if you need to parseInt on the property value in the object)
     * @returns {number}        The index of the property or -1 if not found
     */
    static findObjectIndex = (array, propertyKey, propertyValue, transformation) => {
        if (array !== undefined && array !== null) {
            for (let i = 0; i < array.length; i++) {
                let propertyVal = array[i][propertyKey];
                if (transformation !== undefined) {
                    propertyVal = transformation(propertyVal);
                }

                if (propertyVal === propertyValue) {
                    return i;
                }
            }
        }
        return -1;
    }

    static appendArray = (target, source, cloneArray) => {
        if (cloneArray) {
            target = [...target];
        }

        for (let i = 0; i < source.length; i++) {
            target.push(source[i]);
        }
        return target;
    }

    static prependArray = (target, source, cloneArray) => {
        if (cloneArray) {
            target = [...target];
        }

        target.unshift(source);

        return target;
    }

    static removeFromArray = (target, needle, cloneArray) => {
        if (cloneArray) {
            target = [...target];
        }

        for (let i = target.length - 1; i >= 0; i--) {
            if (target[i] === needle) {
                target.splice(i, 1);
            }
        }

        return target;
    }

}